<mat-toolbar color="primary" class="fixed-navigation-bar">
    <ng-container *ngIf="isDisplayed">
        <!-- <ng-container *ngIf="companySelected">
            <a routerLink="/">
                <img src="assets/SecondaryLogoPurpleOnly.png" class="icon-logo"/>
            </a>
            
        </ng-container>
        <ng-container *ngIf="!companySelected">
            
        </ng-container> -->

        <a routerLink="/company">
            <img src="assets/PrimaryLogoWhiteGreenHorizontal.png" class="full-logo"  />
        </a>        

        <span fxLayout="row" fxLayoutAlign="start center" *ngIf="companySelected" style="margin-left: 100px; line-height:normal;">
            <span class="company-name" [routerLink]="'/company/' + companyId" style="cursor: pointer;">
                {{companyName}}
            </span>
            <span style="margin-left: 40px; font-weight: 400; font-size: 10px;">
                <span fxLayout="row" title="Year-end date">
                    <span fxFlex="65px" fxAlign="end">Year-end:</span>
                    <span fxFlex>{{financialYearEnd | companyDate: region}}</span>
                </span>
                <span fxLayout="row" title="Next period-end processing date">
                    <span fxFlex="65px" fxAlign="end">Period-end:</span>
                    <span fxFlex>{{nextProcessingDate | companyDate: region}}</span>
                </span>
            </span>
        </span>

        <span class="example-fill-remaining-space"></span>
        
        <span *ngIf="loadingSvc.dataLoadingActive | async" [@simpleFadeAnimation]="'in'">
            <mat-progress-spinner color="accent"
                                mode="indeterminate"
                                diameter="25"></mat-progress-spinner>
        </span>

        <!-- <button fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" mat-button 
                (click)="refreshCompanySummary()" 
                [disabled]="isRefreshingSummary"
                *ngIf="companySelected">
            <app-icon-core [icon]="'refresh'" [inline]="false"></app-icon-core>
            <span >Refresh dashboard</span>
        </button> -->

        <button fxLayout="row" fxLayoutAlign="start center" mat-button [matMenuTriggerFor]="helpMenu">
            <app-icon-core fxFlex [icon]="'support'" [inline]="false"></app-icon-core>
            <span fxFlex>Help</span>
        </button>

        <mat-menu #helpMenu="matMenu">
            <a mat-menu-item target="_blank" href="https://youtu.be/dekOfawAyMc?si=SAsj0qOelqrKWvqz">
                Important notice - please view
            </a>
            <a mat-menu-item target="_blank" href="https://farscape-applications.zendesk.com/hc/en-gb">
                Knowledgebase
            </a>
            <a mat-menu-item target="_blank" href="https://youtu.be/xZfLMUFYEjE?si=4PcI-4i-4GHxGldi">
                Full length tutorial
            </a>
            <button mat-menu-item (click)="openHelpCentre()">
                Help &amp; support
            </button>
            <a mat-menu-item target="_blank" href="https://www.nett-tracker.com/privacy">
                Privacy policy
            </a>
            <a mat-menu-item target="_blank" href="https://www.nett-tracker.com/terms">
                Terms of Service
            </a>
        </mat-menu>


        <!-- <button mat-button [matMenuTriggerFor]="accountMenu">
            <mat-icon>perm_identity</mat-icon>
            Account
        </button> -->

        <button mat-button [matMenuTriggerFor]="accountMenu" fxLayout="row" fxLayoutAlign="start center">
            <app-icon-core fxFlex [icon]="'userAccount'" [inline]="false"></app-icon-core>
            <span fxFlex>Account</span>
        </button>

        <mat-menu #accountMenu="matMenu">
            <button mat-menu-item routerLink="/account/details">
                <app-icon-core [icon]="'toolbox'"></app-icon-core>
                Manage
            </button>

            <button mat-menu-item routerLink="/company">
                <app-icon-core [icon]="'companies'"></app-icon-core>
                View companies
            </button>
            <button mat-menu-item routerLink ="company/create">
                <app-icon-core [icon]="'create'"></app-icon-core>
                New company
            </button>
            <!-- <mat-divider></mat-divider>
            <ng-container *ngIf="isUserSystemAdmin">
                <button mat-menu-item (click)="getApiVersion()">
                    Get API Version
                </button>
            </ng-container>
            <button mat-menu-item routerLink="/diagnostics">
                <mat-icon>add_alert</mat-icon>
                Diagnostics
            </button> -->
            
            <button mat-menu-item (click)="logout()">
                <app-icon-core [icon]="'logout'"></app-icon-core>
                Sign-out
            </button>
        </mat-menu>
    </ng-container>
    <ng-container *ngIf="!isDisplayed">
        <a routerLink="/">
            <img src="assets/PrimaryLogoWhiteGreenHorizontal.png" class="full-logo"  />
        </a>  
        <span class="example-fill-remaining-space"></span>

        <span *ngIf="loadingSvc.dataLoadingActive | async" [@simpleFadeAnimation]="'in'" style="margin-right: 20px">
            <mat-progress-spinner color="accent"
                                mode="indeterminate"
                                diameter="25"></mat-progress-spinner>
        </span>

        <span fxHide.lt-sm="true">Month End Made Easy</span>
    </ng-container>
</mat-toolbar>
